import { Typography } from "@mui/material";
import { ReactNode } from "react";

const Title = ({
  children,
  textColor = "normal",
}: {
  children: ReactNode;
  textColor?: string;
}) => {
  return (
    <Typography
      sx={{
        fontWeight: "700",
        paddingX: 10,
        fontSize: {
          xs: "27px",
          sm: "48px",
        },
        textAlign: "center",
        lineHeight: {
          xs: "37px",
          sm: "67px",
        },
        color: textColor,
      }}
      mb={2}
    >
      {children}
    </Typography>
  );
};

export default Title;
